if (!customElements.get('vehicle-fitment-selector')) {
  class VehicleFitmentSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);

      this.yearSelect = this.querySelector('[data-fitment-year]');
      this.modelSelect = this.querySelector('[data-fitment-model]');
      this.makeInput = this.querySelector('[data-fitment-make]');
      this.selectedBikeInput = this.querySelector(
        '[data-fitment-selected-bike]'
      );
      this.status = this.querySelector('[data-fitment-status]');
      this.dataElement = this.querySelector('[data-fitment-data]');

      if (
        !this.form ||
        !this.yearSelect ||
        !this.modelSelect ||
        !this.dataElement
      ) {
        return;
      }

      this.addButton = this.form.querySelector('[name="add"]');

      let rawFitment = '';

      try {
        rawFitment = JSON.parse(this.dataElement.textContent);
      } catch (error) {
        console.error('Unable to read vehicle fitment data.', error);
        return;
      }

      this.fitments = rawFitment
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
          const parts = line.split('|');

          return {
            year: parts[0] ? parts[0].trim() : '',
            make: parts[1] ? parts[1].trim() : '',
            model: parts.slice(2).join('|').trim()
          };
        })
        .filter((record) => {
          return record.year && record.make && record.model;
        });

      if (!this.fitments.length) return;

      this.populateYears();

      this.yearSelect.addEventListener('change', () => {
        this.populateModels();
        this.clearSelection();
        this.validateFitment();
      });

      this.modelSelect.addEventListener('change', () => {
        this.validateFitment();
      });

      /*
       * Dawn can update the Add to Cart button after
       * changing Stock / Shorty.
       *
       * Recheck fitment several times after any product
       * option change so our requirement remains active.
       */
      this.form.addEventListener('change', () => {
        this.scheduleValidation();
      });

      /*
       * HARD STOP:
       * Even if Dawn re-enables the Add to Cart button,
       * a customer cannot click it without valid fitment.
       */
      if (this.addButton) {
        this.addButton.addEventListener(
          'click',
          (event) => {
            if (!this.isValidSelection()) {
              event.preventDefault();
              event.stopImmediatePropagation();

              this.blockPurchase();
            }
          },
          true
        );
      }

      /*
       * Second protection at form submission level.
       */
      this.form.addEventListener(
        'submit',
        (event) => {
          if (!this.isValidSelection()) {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.blockPurchase();
          }
        },
        true
      );

      this.validateFitment();
    }

    scheduleValidation() {
      [0, 50, 150, 300, 600].forEach((delay) => {
        setTimeout(() => {
          this.validateFitment();
        }, delay);
      });
    }

    populateYears() {
      const years = [
        ...new Set(
          this.fitments.map((record) => record.year)
        )
      ].sort((a, b) => Number(b) - Number(a));

      this.yearSelect.innerHTML =
        '<option value="">Select Year</option>';

      years.forEach((year) => {
        const option = document.createElement('option');

        option.value = year;
        option.textContent = year;

        this.yearSelect.appendChild(option);
      });
    }

    populateModels() {
      const selectedYear = this.yearSelect.value;

      this.modelSelect.innerHTML = '';

      if (!selectedYear) {
        const option = document.createElement('option');

        option.value = '';
        option.textContent = 'Select Year First';

        this.modelSelect.appendChild(option);
        this.modelSelect.disabled = true;

        return;
      }

      const models = [
        ...new Set(
          this.fitments
            .filter((record) => {
              return record.year === selectedYear;
            })
            .map((record) => record.model)
        )
      ].sort((a, b) => a.localeCompare(b));

      const placeholder = document.createElement('option');

      placeholder.value = '';
      placeholder.textContent = 'Select Model';

      this.modelSelect.appendChild(placeholder);

      models.forEach((model) => {
        const option = document.createElement('option');

        option.value = model;
        option.textContent = model;

        this.modelSelect.appendChild(option);
      });

      this.modelSelect.disabled = false;
    }

    getSelectedRecord() {
      const year = this.yearSelect.value;
      const model = this.modelSelect.value;

      if (!year || !model) return null;

      return (
        this.fitments.find((record) => {
          return (
            record.year === year &&
            record.model === model
          );
        }) || null
      );
    }

    isValidSelection() {
      return Boolean(this.getSelectedRecord());
    }

    clearSelection() {
      if (this.makeInput) {
        this.makeInput.value = '';
      }

      if (this.selectedBikeInput) {
        this.selectedBikeInput.value = '';
      }
    }

    blockPurchase() {
      this.clearSelection();

      this.status.textContent =
        'Please select your motorcycle year and model before adding this product to your cart.';

      this.status.classList.remove('is-compatible');

      if (this.addButton) {
        this.addButton.disabled = true;
      }

      this.yearSelect.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    validateFitment() {
      const record = this.getSelectedRecord();

      if (!record) {
        this.clearSelection();

        if (!this.yearSelect.value) {
          this.status.textContent =
            'Please select your motorcycle.';
        } else if (!this.modelSelect.value) {
          this.status.textContent =
            'Now select your motorcycle model.';
        } else {
          this.status.textContent =
            'This motorcycle is not listed as compatible with this product.';
        }

        this.status.classList.remove('is-compatible');

        if (this.addButton) {
          this.addButton.disabled = true;
        }

        return;
      }

      if (this.makeInput) {
        this.makeInput.value = record.make;
      }

      if (this.selectedBikeInput) {
        this.selectedBikeInput.value =
          `${record.year} ${record.make} ${record.model}`;
      }

      this.status.textContent =
        `✓ Fits your ${record.year} ${record.make} ${record.model}`;

      this.status.classList.add('is-compatible');

      if (this.addButton) {
        this.addButton.disabled = false;
      }
    }
  }

  customElements.define(
    'vehicle-fitment-selector',
    VehicleFitmentSelector
  );
}
/*
 * Global fitment hard guard.
 * Protects dynamically rendered/replaced Dawn product forms.
 */

if (!window.__vehicleFitmentHardGuard) {
  window.__vehicleFitmentHardGuard = true;

  function getFitmentForm(selector) {
    const formId = selector.dataset.formId;

    if (formId) {
      const form = document.getElementById(formId);
      if (form) return form;
    }

    return selector.closest('form');
  }

  function fitmentComplete(selector) {
    const year = selector.querySelector('[data-fitment-year]');
    const model = selector.querySelector('[data-fitment-model]');

    return Boolean(
      year &&
      model &&
      year.value.trim() !== '' &&
      model.value.trim() !== ''
    );
  }

  function lockIncompleteFitmentForms() {
    document
      .querySelectorAll('vehicle-fitment-selector')
      .forEach((selector) => {
        const form = getFitmentForm(selector);

        if (!form) return;

        const button = form.querySelector('[name="add"]');

        if (!button) return;

        if (!fitmentComplete(selector)) {
          button.disabled = true;
        }
      });
  }

  /*
   * HARD CLICK BLOCK.
   * Runs before Dawn's own Add to Cart code.
   */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('[name="add"]');

      if (!button) return;

      const form = button.closest('form');

      if (!form) return;

      const selector = document.querySelector(
        `vehicle-fitment-selector[data-form-id="${form.id}"]`
      );

      if (!selector) return;

      if (!fitmentComplete(selector)) {
        event.preventDefault();
        event.stopImmediatePropagation();

        button.disabled = true;

        const status = selector.querySelector(
          '[data-fitment-status]'
        );

        if (status) {
          status.textContent =
            'Please select your motorcycle year and model before adding this product to your cart.';

          status.classList.remove('is-compatible');
        }

        selector.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    true
  );

  /*
   * HARD SUBMIT BLOCK.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const selector = document.querySelector(
        `vehicle-fitment-selector[data-form-id="${form.id}"]`
      );

      if (!selector) return;

      if (!fitmentComplete(selector)) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const button = form.querySelector('[name="add"]');

        if (button) {
          button.disabled = true;
        }
      }
    },
    true
  );

  /*
   * When Dawn replaces product HTML or a variant button,
   * immediately lock the new button again if bike info is blank.
   */
  const fitmentMutationObserver = new MutationObserver(() => {
    lockIncompleteFitmentForms();
  });

  fitmentMutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Variant option changes can cause Dawn to render new HTML
   * shortly after the click/change.
   */
  document.addEventListener('change', function () {
    [0, 50, 150, 300, 600].forEach((delay) => {
      setTimeout(lockIncompleteFitmentForms, delay);
    });
  });

  lockIncompleteFitmentForms();
}